﻿import type {
    ContactFieldDto,
    DateTimeFieldDto,
    FieldDtoBase,
    ImageFieldDto,
    LocationDirectionsFieldDto,
    PackageFieldDto,
    SuitableForFieldDto,
    TagsFieldDto,
    TextFieldDto
} from '@/types'

export function isDateField(field: FieldDtoBase): field is DateTimeFieldDto {
    return field.type.includes('date')
}
export function isTagsField(field: FieldDtoBase): field is TagsFieldDto {
    return field.type.includes(field.type)
}
export function isTextField(field: FieldDtoBase): field is TextFieldDto {
    return ['title', 'description', 'teaser'].includes(field.type)
}
export function isImageField(field: FieldDtoBase): field is ImageFieldDto {
    return field.type.includes('image')
}
export function isLocationDirectionsField(field: FieldDtoBase): field is LocationDirectionsFieldDto {
    return field.type.includes('locationDirections')
}
export function isSuitableForField(field: FieldDtoBase): field is SuitableForFieldDto {
    return ['suitableFor'].includes(field.type)
}
export function isPackageField(field: FieldDtoBase): field is PackageFieldDto {
    return ['package'].includes(field.type)
}
export function isContactField(field: FieldDtoBase): field is ContactFieldDto {
    return ['contact'].includes(field.type)
}
// export function isRegularField(field: FieldDtoBase): field is FieldDto {
//     return !['package', 'contact'].includes(field.type)
// }



